import { render, staticRenderFns } from "./Conversation.vue?vue&type=template&id=ff793fd0&scoped=true&lang=pug&"
import script from "./Conversation.vue?vue&type=script&lang=js&"
export * from "./Conversation.vue?vue&type=script&lang=js&"
import style0 from "./Conversation.vue?vue&type=style&index=0&id=ff793fd0&lang=scss&scoped=true&"
import style1 from "./Conversation.vue?vue&type=style&index=1&id=ff793fd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff793fd0",
  null
  
)

export default component.exports